import PropTypes from "prop-types";
import "./ui.css";

const OPTIONS = [10, 20, 30, 50];

// Replaces the "Number of entries per page" box from ViewOption.jsx. Every
// option sits inside the 10–50 range that changeRowsPerPage() accepts.
export default function RowsPerPageSelect({ value, onChange }) {
  const current = Number(value);
  const options = OPTIONS.includes(current) ? OPTIONS : [...OPTIONS, current].sort((a, b) => a - b);
  return (
    <label className="simcc-rows-per-page">
      Rows
      <select value={current} onChange={(e) => onChange(Number(e.target.value))}>
        {options.map((n) => (
          <option key={n} value={n}>
            {n}
          </option>
        ))}
      </select>
    </label>
  );
}

RowsPerPageSelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onChange: PropTypes.func.isRequired,
};
